import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider.jsx';
import { hasRole } from '../lib/roles.js';
import { SevricLoader } from '../../../chat/src/index.js';

// Route guard. Renders children only when the user is authenticated and (if a
// minimum role is required) has it. Behavior on insufficient role:
//   - if `redirectTo` is provided, send them there silently (used to bounce
//     technicians off pipeline/admin screens straight to /inspect — they
//     should never see those surfaces, not even as a "not authorized" panel)
//   - otherwise show a clear "not authorized" panel
//
// Loading state shows a centered spinner — never a blank protected screen,
// which avoids the flash-of-unauthenticated-content (FOUC) leak from v2.9.
export function RequireAuth({ children, role, redirectTo }) {
  const { status, profile } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <SevricLoader app="recon" />;
  }

  if (status === 'unauthenticated' || status === 'error') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (role && !hasRole(profile?.role, role)) {
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }
    return (
      <div className="container">
        <div className="panel">
          <h3>Not authorized</h3>
          <p>
            Your account ({profile?.role}) doesn't have access to this area. If
            you believe this is a mistake, ask your store admin to update your
            role in the SEVRIC portal.
          </p>
        </div>
      </div>
    );
  }

  return children;
}
